<template>
  <section class="hero is-fullheight" id="hero">
        <div class="hero-body">
            <div class="hero-content">
                <h1 class="title is-1">
                    SHINE
                </h1>
                <h3 class="subtitle">
                    WELCOME TEMPLATE STOCK
                </h3>
                <p class="content">
                    Lorem ipsum dolor sit amet.
                </p>
            </div>
        </div>
    </section>
</template>
<script type="text/javascript">
export default {
  name: 'hero',
  data(){return{
    img:require('../assets/logo.png')
  }}
}
</script>

<style media="screen">

</style>
